import { RoleCode } from "../../utils/RolesPermissions";

export const RoutePostAuthLogin = "/auth/login";

export interface PayloadPostAuthLogin {
  email: string;
  password: string;
}

export interface ResponsePostAuthLogin {
  token: string;
  user: User;
}

export interface User {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  userType: "MERCHANT_USER" | "ADMIN_USER";
  merchantId: number;
  merchantName: string;
  ssoProvider: "NON_SSO" | "JUMPCLOUD";
  roleCode: RoleCode;
  createdAt?: string;
}
